exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".cCgtFdTJxNzMYWxMPWzRt{margin-left:-5.71429rem}.cCgtFdTJxNzMYWxMPWzRt>div,.cCgtFdTJxNzMYWxMPWzRt>div>div,.cCgtFdTJxNzMYWxMPWzRt>div>div>div{width:21.42857rem}._2Pjg7RhesWiI9GYb6SHVft{min-width:5.71429rem;overflow:hidden}@media only screen and (min-width:640px){.cCgtFdTJxNzMYWxMPWzRt{margin-left:-1.07143rem;min-width:14.28571rem}}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"MemberCardTd_studentCard": "cCgtFdTJxNzMYWxMPWzRt",
	"MemberCardTd_content": "_2Pjg7RhesWiI9GYb6SHVft"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/build-omni-operation-ui_develop/node_modules/omni-common-ui/postcss.config.js"}}!./components/TableView/Tds/MemberCardTd/style.postcss
// module id = 1260
// module chunks = 0